import * as React from "react";
import styled from "styled-components";
import useEntityTitles from "hooks/useEntityTitles";
import { Link, Spinner } from "components/common";
import { Table } from "components/bootstrap";
import { formatCount } from "components/inputs/helpers/InputThroughputUtils";
import { useInputMetricsFor } from "components/inputs/InputsOveriew/InputMetricsContext";
import Routes from "routing/Routes";
const StreamColumn = styled.col`
  width: 80%;
`;
const MessagesColumn = styled.col`
  width: 20%;
`;
const MessageCountHeadCell = styled.th`
  text-align: right;
`;
const MessageCountCell = styled.td`
  font-variant-numeric: tabular-nums;
  text-align: right;
`;
const MessagesPerStreamSection = ({ input }) => {
  const { metrics, isInitialLoading, isError } = useInputMetricsFor(input.id);
  const messagesPerStream = metrics == null ? void 0 : metrics.messages_per_stream;
  const streamIds = messagesPerStream ? Object.keys(messagesPerStream) : [];
  const titleEntities = streamIds.map((id) => ({ id, type: "streams" }));
  const { titlesById, isInitialLoading: areTitlesLoading } = useEntityTitles(titleEntities);
  if (isInitialLoading && !messagesPerStream) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement("p", null, "Could not load messages per stream.");
  }
  if (!messagesPerStream || streamIds.length === 0) {
    return /* @__PURE__ */ React.createElement("p", null, "No streams have received messages from this input in the last 24 hours.");
  }
  const sortedEntries = Object.entries(messagesPerStream).sort(([, a], [, b]) => b - a);
  return /* @__PURE__ */ React.createElement(Table, { bordered: true, condensed: true }, /* @__PURE__ */ React.createElement("colgroup", null, /* @__PURE__ */ React.createElement(StreamColumn, null), /* @__PURE__ */ React.createElement(MessagesColumn, null)), /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Stream"), /* @__PURE__ */ React.createElement(MessageCountHeadCell, null, "Messages"))), /* @__PURE__ */ React.createElement("tbody", null, sortedEntries.map(([streamId, count]) => {
    const title = titlesById[streamId];
    const label = title != null ? title : areTitlesLoading ? streamId : `${streamId} (deleted)`;
    return /* @__PURE__ */ React.createElement("tr", { key: streamId }, /* @__PURE__ */ React.createElement("td", null, title ? /* @__PURE__ */ React.createElement(Link, { to: Routes.stream_view(streamId) }, label) : label), /* @__PURE__ */ React.createElement(MessageCountCell, null, formatCount(count)));
  })));
};
export default MessagesPerStreamSection;
